import * as React from 'react'
import {Box} from "@mui/material";
import {formatPriceSymbol} from "@ui-seeker/utils";


export default function priceColumn(key, label, showListPrice=false) {
	return {
		name: key, label: label,
		options: {
			setCellHeaderProps: () => ({ sx: {
				whiteSpace: 'pre-wrap',
			}}),
			customBodyRowRenderLite: (value, { currency, listPrice }) => <Box sx={{ textAlign: 'center' }}>
				{formatPriceSymbol(value, currency, { displayZero: true })}
				{ !!showListPrice && !!listPrice && value !== listPrice && <Box sx={{ fontSize: 11, ml: 1, textDecoration: 'line-through' }}>
					{formatPriceSymbol(listPrice, currency)}
				</Box> }
			</Box>
		}
	}
}